import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityReadAction from './legalEntityRead.action.json' with { type: 'json' }

const legalEntityReadDefinition = defineReadAutoAction(legalEntityReadAction, 'legalEntity')

export default legalEntityReadDefinition
